<template>
  <v-dialog v-model="dialog" fullscreen lazy hide-overlay scrollable>
    <v-card>
      <v-toolbar color="primary" dark tabs>
        <!-- No esta mostrando el titulo bien <v-toolbar-title>{{selected.text}}</v-toolbar-title> -->
        <v-spacer />
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
        <v-tabs
          slot="extension"
          v-model="tab"
          color="primary"
          slider-color="white"
          centered
        >
          <v-tab :disabled="!selected._id">
            {{ $tc('titles.notifications.information') }}
          </v-tab>
          <v-tab v-show="selected._id && selected.sendType.includes('push')">
            {{
              `${$tc('titles.notifications.receivers')} (${$t(
                'fields.notifications.sendTypes.push'
              )})`
            }}
          </v-tab>
          <v-tab v-show="selected._id && selected.sendType.includes('email')">
            {{
              `${$tc('titles.notifications.receivers')} (${$t(
                'fields.notifications.sendTypes.email'
              )})`
            }}
          </v-tab>
          <v-tab>{{ $tc('titles.notifications.statistics') }}</v-tab>
        </v-tabs>
      </v-toolbar>
      <v-card-text>
        <v-tabs-items v-model="tab">
          <v-tab-item ripple>
            <tab-information
              v-if="selected._id"
              :notification-id="selected._id"
              :edit="false"
              notification-view
            />
          </v-tab-item>
          <v-tab-item
            v-show="selected._id && selected.sendType.includes('push')"
            ripple
          >
            <tab-receivers
              v-if="selected._id && selected.sendType.includes('push')"
              :notification-id="selected._id"
              :type="selected.type"
              send-type="push"
            />
          </v-tab-item>
          <v-tab-item
            v-show="selected._id && selected.sendType.includes('email')"
            ripple
          >
            <tab-receivers
              v-if="selected._id && selected.sendType.includes('email')"
              :notification-id="selected._id"
              :type="selected.type"
              send-type="email"
            />
          </v-tab-item>
          <v-tab-item ripple>
            <tab-stats />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <meta-button type="cancel" @click="cancel" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import TabInformation from './TabInformation'
import TabReceivers from './TabReceivers'
import TabStats from './TabStats'

export default {
  name: 'NotificationView',
  components: {
    TabInformation,
    TabReceivers,
    TabStats,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      tab: 0,
    }
  },
  watch: {
    dialog(val) {
      if (!val) this.cancel()
    },
  },
  computed: {
    ...mapState({
      selected: (state) => state.notifications.selected,
    }),
  },
  methods: {
    ...mapActions({
      reset: 'notifications/reset',
    }),
    cancel() {
      this.tab = 0
      this.reset()
      this.$emit('close')
    },
  },
}
</script>
